import store from 'store';

const AUTH_KEY = 'auth';
const RETURN_TO_KEY = 'returnTo';

const ACTIVITY_ENTRIES_KEY = 'activityEntries';
const ACTIVITY_ENTRIES_DEFAULT = [];

const METERED_CONTENT_KEY = 'meteredContent';
const METERED_CONTENT_DEFAULT = {};

const LAST_PRODUCT_SLUG_KEY = 'lastProductSlug';
const LAST_PRODUCT_SLUG_DEFAULT = undefined;

const defaultAuth = {
  email: null,
  accessToken: null,
  isImpersonated: null,
};
const clearAuth = () => store.set(AUTH_KEY, null);
const getAuth = () => store.get(AUTH_KEY) || defaultAuth;
const setAuth = (auth) => store.set(AUTH_KEY, auth);

const defaultReturnTo = null;
const clearReturnTo = () => store.set(RETURN_TO_KEY, null);
const getReturnTo = () => store.get(RETURN_TO_KEY) || defaultReturnTo;
const setReturnTo = (returnTo) => store.set(RETURN_TO_KEY, returnTo);

const activityEntries = {
  get: () => store.get(ACTIVITY_ENTRIES_KEY) || ACTIVITY_ENTRIES_DEFAULT,
  set: (val) => store.set(ACTIVITY_ENTRIES_KEY, val),
};

const meteredContent = {
  get: () => store.get(METERED_CONTENT_KEY) || METERED_CONTENT_DEFAULT,
  set: (val) => store.set(METERED_CONTENT_KEY, val),
};

const lastProductSlug = {
  get: () => store.get(LAST_PRODUCT_SLUG_KEY) || LAST_PRODUCT_SLUG_DEFAULT,
  set: (val) => store.set(LAST_PRODUCT_SLUG_KEY, val),
};

const storage = {
  activityEntries,
  clearAuth,
  clearReturnTo,
  getAuth,
  getReturnTo,
  lastProductSlug,
  meteredContent,
  setAuth,
  setReturnTo,
};

export default storage;
